/**
 * The `page_id` an app route reports, derived from its route path pattern:
 * the static segments only, joined back up. Params (`:userId`) and the splat
 * (`*`) are the instance, not the page — `admin/user/:userId/edit` is one
 * page whichever user is being edited. The Mixpanel "Page entity" custom
 * property maps these verbatim, so a route path rename renames the id too.
 *
 * A path made entirely of params derives nothing; such a route reports no
 * visit (see `reducedRoutes`).
 */
export const derivePageId = (path: string): string =>
  path
    .split('/')
    .filter((segment) => segment && !segment.startsWith(':') && segment !== '*')
    .join('/');
